export default __webpack_public_path__ + "static/char-thumb-30-fcd18f215bddaedbf944f12ee26b98e1.png";